import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const HomeIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 12l8.954-8.955a.75.75 0 011.06 0L21.218 12M4.5 9.75V21a.75.75 0 00.75.75H9.75V15a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v6.75h4.5A.75.75 0 0019.5 21V9.75M8.25 21.75h7.5"
    />
  );

  return (
    <Icon
      svgPath={svgPath}
      className={className}
      title={title}
      fill="none"
      strokeWidth={1.5}
    />
  );
};

export default HomeIcon;
